import React from "react";
import LOGO_EPAYCO from "../../assets/epayco-logo.png";
import {
	Page,
	Text,
	View,
	Image,
	Document,
	StyleSheet,
	Font,
	pdf
} from "@react-pdf/renderer";

const FONT_WEIGHT = 800;

Font.register({
	family: "Open Sans",
	fonts: [
		{
			src:
				"https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf"
		},
		{
			src: `https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-${FONT_WEIGHT}.ttf`,
			fontWeight: FONT_WEIGHT
		}
	]
});

const saveBlob = (blob, filename) => {
	let a = document.createElement("a");
	document.body.appendChild(a);
	a.style.display = "none";
	let url = window.URL.createObjectURL(blob);
	a.href = url;
	a.download = filename;
	a.click();
	window.URL.revokeObjectURL(url);
};

export const savePDF = async (document, filename) => {
	saveBlob(await pdf(document).toBlob(), filename);
};

const Row = props => (
	<View style={styles.row.container}>
		<View>
			<Text style={styles.row.name}>{props.name}</Text>
		</View>
		<View>
			<Text style={styles.row.value}>
				{props.value ? props.value : "----------------"}
			</Text>
		</View>
	</View>
);

const TemplatePDF = props => {
	const {
		subscriptionPDFData,
		infoEmpresa,
		message,
		subscriptionStatus
	} = props;

	const SUBSCRIPTION_RESULT_COLORS = {
		Pendiente: "#F2C94C",
		Aceptada: "#27AE60",
		Rechazada: "#EB5757",
		Fallida: "#EB5757"
	};
	const MESSAGES = {
		Pendiente: [
			"Detalles de factura a suscribir",
			"Detalles de la factura por pagar"
		],
		Aceptada: ["Detalles de factura suscrita", "Detalles de la factura pagada"],
		Rechazada: ["Detalles de factura a suscribir", "Detalles de pago"],
		Fallida: ["Detalles de factura a suscribir", "Detalles de pago"]
	};

	return (
		<Document>
			<Page size="A4">
				<View style={styles.imageContainer}>
					<Image src={LOGO_EPAYCO} style={styles.image} />
				</View>

				{subscriptionStatus ? (
					<View
						style={{
							...styles.status,
							backgroundColor: SUBSCRIPTION_RESULT_COLORS[subscriptionStatus]
						}}
					>
						<Text>{message ? message : null}</Text>
					</View>
				) : null}

				<View style={styles.header}>
					<Text>Detalles del proceso realizado:</Text>
				</View>

				<View style={styles.info}>
					<View style={styles.details}>
						<View style={styles.title}>
							<Text>Detalles de Comercio</Text>
						</View>
						<Row name="Nombre" value={infoEmpresa.nombreEmpresa} />
						<Row name="NIT" value={infoEmpresa.nit} />
					</View>

					<View style={styles.details}>
						<View style={styles.title}>
							<Text>
								{
									MESSAGES[
										subscriptionStatus ? subscriptionStatus : "Pendiente"
									][0]
								}
							</Text>
						</View>
						{subscriptionPDFData.responseFactura.map(row => (
							<Row
								name={row.name}
								value={
									row.name === "Valor" ||
									row.name === "Valor a pagar." ||
									row.name === "Valor a pagar"
										? `$${row.value.toFixed(3)} COP`
										: row.value
								}
								key={row.name}
							/>
						))}
					</View>

					<View style={styles.details}>
						<View style={styles.title}>
							<Text>Detalles de suscripción</Text>
						</View>
						<Row
							name="Nombre suscripción"
							value={subscriptionPDFData.detalleSuscripcion.nombreSuscripcion}
						/>
						<Row
							name="Número suscripción"
							value={subscriptionPDFData.detalleSuscripcion.numeroSuscripcion}
						/>
						<Row
							name="Medio de pago"
							value={subscriptionPDFData.detalleSuscripcion.medioPago}
						/>
						<Row
							name="Forma de cobro"
							value={subscriptionPDFData.detalleSuscripcion.formaCobro}
						/>
						<Row
							name="Próxima fecha de cobro"
							value={subscriptionPDFData.detalleSuscripcion.proximoCobro}
						/>
					</View>

					{subscriptionPDFData.responseTransaction && (
						<View style={styles.details}>
							<View style={styles.title}>
								<Text>
									{
										MESSAGES[
											subscriptionStatus ? subscriptionStatus : "Pendiente"
										][1]
									}
								</Text>
							</View>
							<Row
								name="Referencia"
								value={subscriptionPDFData.responseTransaction.referencia}
							/>
							<Row
								name="Medio de pago"
								value={subscriptionPDFData.responseTransaction.metodoPago}
							/>
							<Row
								name="Número de recibo"
								value={subscriptionPDFData.responseTransaction.numeroRecibo}
							/>
							<Row
								name="Total"
								value={
									subscriptionPDFData.responseTransaction.total
										? `$${subscriptionPDFData.responseTransaction.total} COP`
										: null
								}
							/>
						</View>
					)}
				</View>
			</Page>
		</Document>
	);
};

const styles = StyleSheet.create({
	imageContainer: {
		marginTop: 8,
		height: "100",
		justifyContent: "center",
		alignItems: "center"
	},
	image: {
		height: 45,
		width: 140
	},
	status: {
		height: 50,
		color: "white",
		fontSize: 17,
		alignItems: "center",
		justifyContent: "center"
	},
	header: {
		marginTop: 35,
		color: "#444",
		fontSize: 14,
		alignItems: "center",
		justifyContent: "center"
	},
	info: {
		marginHorizontal: "40",
		color: "#444"
	},
	details: {
		marginTop: 24
	},
	title: {
		fontFamily: "Open Sans",
		fontSize: 12,
		borderBottom: "1pt solid #777",
		paddingBottom: 5,
		fontWeight: FONT_WEIGHT
	},
	row: {
		container: {
			fontSize: 13,
			borderBottom: "1pt solid #777",
			justifyContent: "space-between",
			flexDirection: "row",
			paddingVertical: 4
		},
		name: {
			color: "#444"
		},
		value: {
			color: "#666"
		}
	}
});

export default TemplatePDF;
